import { useState } from 'react';
import { Button, Grid, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { EstateType } from 'queries';

import EstateTypeSelectBox from './estate-type-select-box';

type Props = {
  onExitClick: () => void;
  onSubmit: (selectedType: EstateType) => void;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    h5: {
      paddingTop: '0px',
      paddingBottom: '15px',
    },
    h6: {
      paddingTop: '0px',
      paddingBottom: '15px',
    },
    previousButton: {
      width: '40%',
      borderRadius: '25px',
      marginRight: theme.spacing(5),
      backgroundColor: 'white',
      color: 'black',
      border: '1px solid black',
    },
    nextButton: {
      width: '40%',
      borderRadius: '25px',
      backgroundColor: '#5ED1F0',
      color: 'black',
    },
    estateTypeRow: {
      paddingTop: '15px',
      paddingBottom: '15px',
    },
    estateTypeIcon: {
      textAlign: 'center',
      height: '130px',
      paddingBottom: '15px',
    },
    estateTypeLabel: {
      textAlign: 'center',
      fontSize: '20px',
    },
    estateTypeCheckbox: {
      color: 'black',
    },
    estateTypeDescription: {
      padding: '5px',
    },
    trustAdminLogo: {
      width: '130px',
    },
  }),
);

export default function EstateGetStartedForm({ onExitClick, onSubmit }: Props) {
  const [selectedType, setSelectedType] = useState<EstateType>();
  const classes = useStyles();

  const handleSubmit = () => {
    if (selectedType) {
      onSubmit(selectedType);
    }
  };

  const handleSelect = (estateType: EstateType) => {
    setSelectedType(estateType);
  };

  const estateTypes = [
    { type: EstateType.Truplanning, label: 'Truplanning' },
    { type: EstateType.Truadmin, label: 'Truadmin' },
    { type: EstateType.Trustadmin, label: 'Trustadmin' },
    { type: EstateType.Truproxy, label: 'Truproxy' },
  ];

  return (
    <>
      <Typography variant="h5" className={classes.h5}>
        Let's create your estate dashboard.
      </Typography>
      <Typography variant="h6" className={classes.h6}>
        First, what type of matter is this?
      </Typography>

      <Grid container>
        {estateTypes.map((estate) => (
          <EstateTypeSelectBox
            key={estate.type}
            estateType={estate.type}
            selected={selectedType === estate.type}
            setSelected={() => handleSelect(estate.type)}
          />
        ))}
      </Grid>

      <Button
        className={classes.previousButton}
        color="primary"
        onClick={onExitClick}
        variant="contained"
      >
        Exit
      </Button>
      <Button
        className={classes.nextButton}
        onClick={handleSubmit}
        disabled={!selectedType}
        color="secondary"
        variant="contained"
        type="button"
      >
        Next
      </Button>
    </>
  );
}
